import {
  Box,
  Grid2,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { colors } from "../theme/theme";
import { CustomBtn } from "../Components/Common/CustomBtn";
import { LoginRounded } from "@mui/icons-material";
import {
  GoogleOAuthProvider,
  googleLogout,
  useGoogleLogin,
} from "@react-oauth/google";
import axiosInstance from "../utils/config/config";
import { useDispatch } from "react-redux";
import { getUserById } from "../redux/actions/user.dispatcher";

const AuthLayout = ({ type, children, forgotPass }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        // ✅ Fetch user details from Google's API
        const res = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );

        const user = await res.json();

        // ✅ Extract useful data
        const userData = {
          name: user.name,
          email: user.email,
          profilePic: user.picture,
        };

        // Send userData to backend if needed

        const loginResponse = await axiosInstance.post(
          `/user/createUserIfNotExists`,
          {
            name: user.name,
            email: user.email,
            profilePic: user.picture,
          }
        );

        const response = loginResponse?.data;

        localStorage.setItem("authToken", response?.accessToken);

        if (response) {
          dispatch(getUserById(response?.user?.id)).then((res) => {
            if (response?.message === "User was registered successfully!") {
              navigate("/onboarding");
            } else {
              navigate("/dashboard");
            }
          });
        }
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    },
    onError: (error) => console.error("Google Login Failed:", error),
  });
  const smallScreen = useMediaQuery("(max-width:800px)");

  return (
    <Grid2
      container
      component="main"
      sx={{ backgroundColor: colors.bg, height: "100vh" }}
    >
      {!smallScreen && (
        <Grid2
          size={{ xs: false, sm: 5, md: 6.5 }}
          item
          sx={{
            backgroundImage: `url(${require("../assets/images/mma-stock-2.png")})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              height: "10%",
              backgroundColor: "#000",
              width: "100%",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: "10%",
              left: 0,
              width: "100%",
              height: "60%",
              backgroundImage:
                "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.479955) 27.72%, #000000 81.28%)",
            }}
          />

          <Box
            sx={{
              mx: smallScreen ? 2 : 6,
              position: "absolute",
              bottom: forgotPass ? "0%" : "15%",
              height: "40%",
            }}
          >
            <Typography
              sx={{
                fontWeight: "400",
                color: "#fff",
                fontSize: smallScreen ? "20px" : "30px",
                lineHeight: "60px",
                maxWidth: "90%",
                fontFamily: "Inter-Regular",
              }}
            >
              Step Into the Cage! Join the OnlyHands MMA Community!
              <Typography
                component={"span"}
                sx={{
                  fontWeight: "700",
                  color: "#fff",
                  lineHeight: "60px",
                  fontFamily: "Inter-Bold",
                  fontSize: smallScreen ? "20px" : "30px",
                }}
              >
                {" "}
                Train Smarter. Get Stronger. Connect with Elite Coaches.
              </Typography>
            </Typography>

            {!forgotPass && (
              <>
                <Typography
                  sx={{
                    fontWeight: "400",
                    color: "#fff",
                    opacity: 0.6,
                    fontSize: smallScreen ? "12px" : "20px",
                    mt: 2,
                    fontFamily: "Inter-Light",
                    maxWidth: "80%",
                    lineHeight: "30px",
                  }}
                >
                  🔥Unlock exclusive MMA training, expert advice, and premium
                  training media content.
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                  }}
                >
                  <CustomBtn
                    text={type === "login" ? "Register" : "Login"}
                    Icon={LoginRounded}
                    width={"20%"}
                    onClick={() => {
                      type === "login"
                        ? navigate("/register")
                        : navigate("/login");
                    }}
                  />
                </Box>
              </>
            )}
          </Box>
        </Grid2>
      )}

      <Grid2
        size={{ xs: 12, sm: 12, md: 5.5 }}
        item
        component={Paper}
        elevation={6}
        square
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#F7F8FA",
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: "120px",
            px: 4,
            py: 2,
            backgroundColor: colors.bg,
          }}
        >
          <img
            src={require("../assets/icons/logo-sm.png")}
            style={{ width: "150px", height: "60px", marginRight: "40px" }}
            alt="logo"
          />
        </Box>
        <Box
          sx={{
            my: type === "register" ? 0 : smallScreen ? 0 : 3,
            mb: type === "register" ? 4 : 0,
            mx: forgotPass ? 4 : smallScreen ? 4 : 12,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {!forgotPass && (
            <>
              <Typography
                sx={{
                  fontWeight: "400",
                  color: "#000",
                  fontSize: "30px",
                  lineHeight: "60px",
                  fontFamily: "Inter-Bold",
                }}
              >
                {type === "login" ? "Login Page" : "Register Page"}
              </Typography>

              <Stack
                direction={"row"}
                spacing={2}
                mt={2}
                justifyContent={"space-between"}
              >
                <Stack
                  spacing={2}
                  direction={"row"}
                  sx={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    border: `1px solid ${colors.primary}`,
                    py: 1.5,
                    cursor: "pointer",
                  }}
                  onClick={googleLogin}
                >
                  <img
                    src={require("../assets/icons/google.png")}
                    style={{
                      width: "22px",
                      height: "22px",
                    }}
                    alt="google"
                  />
                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: "#000",
                      fontFamily: "Inter-Medium",
                    }}
                  >
                    Google
                  </Typography>
                </Stack>
                {/* <Stack
                  spacing={1}
                  direction={"row"}
                  sx={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: "47.5%",
                    border: `1px solid #000`,
                    py: 1.5,
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={require("../assets/icons/apple.png")}
                    style={{
                      width: "35px",
                      height: "22px",
                    }}
                    alt="Apple"
                  />
                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: "#000",
                      fontFamily: "Inter-Medium",
                    }}
                  >
                    Apple
                  </Typography>
                </Stack> */}
              </Stack>

              <Stack
                direction={"row"}
                sx={{
                  my: 4,
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{ width: "17%", height: "1px", backgroundColor: "#000" }}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#000",
                    fontFamily: "Inter-Regular",
                    mx: 2,
                    letterSpacing: "2.5px",
                    textAlign: "center",
                  }}
                >
                  {type === "login" ? "OR LOG IN WITH" : "OR REGISTER WITH"}
                </Typography>
                <Box
                  sx={{ width: "15%", height: "1px", backgroundColor: "#000" }}
                />
              </Stack>
            </>
          )}

          {children}
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default AuthLayout;
